const saveProducts = (data) => ({
    type: "SAVE_PRODUCTS",
    payload: data, 
  });
  
  export { saveProducts };
  